/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateIngressRequestBody,
  UpdateIngressRequestBody$Outbound,
  UpdateIngressRequestBody$outboundSchema,
} from "../components/updateingressrequestbody.js";

export type UpdateNetworkIngressSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateNetworkIngressRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateIngressRequestBody: UpdateIngressRequestBody;
};

/** @internal */
export type UpdateNetworkIngressSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateNetworkIngressSecurity$outboundSchema: z.ZodMiniType<
  UpdateNetworkIngressSecurity$Outbound,
  UpdateNetworkIngressSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateNetworkIngressSecurityToJSON(
  updateNetworkIngressSecurity: UpdateNetworkIngressSecurity,
): string {
  return JSON.stringify(
    UpdateNetworkIngressSecurity$outboundSchema.parse(
      updateNetworkIngressSecurity,
    ),
  );
}

/** @internal */
export type UpdateNetworkIngressRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateIngressRequestBody: UpdateIngressRequestBody$Outbound;
};

/** @internal */
export const UpdateNetworkIngressRequest$outboundSchema: z.ZodMiniType<
  UpdateNetworkIngressRequest$Outbound,
  UpdateNetworkIngressRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateIngressRequestBody: UpdateIngressRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateIngressRequestBody: "UpdateIngressRequestBody",
    });
  }),
);

export function updateNetworkIngressRequestToJSON(
  updateNetworkIngressRequest: UpdateNetworkIngressRequest,
): string {
  return JSON.stringify(
    UpdateNetworkIngressRequest$outboundSchema.parse(
      updateNetworkIngressRequest,
    ),
  );
}
